import { lazy, ReactNode, Suspense } from "react"
import { RouteObject } from "react-router-dom"
import { Loading } from "antd-mobile"

const A20211224mysterybox = lazy(
  () => import("src/pages/activity/a20211224mysterybox")
)
const FacialMask = lazy(() => import("src/pages/activity/facialMask"))
const FacialMaskHome = lazy(() => import("src/pages/activity/facialMaskHome"))
const BlindBox = lazy(() => import("src/pages/purchase/blindBox"))
const Azzza = lazy(() => import("src/pages/activity/azzza"))
const AzzzaPurchase = lazy(() => import("src/pages/purchase/azzza"))
const PheebsTiger = lazy(() => import("src/pages/activity/pheebsTiger"))
const PheebsTigerPurchase = lazy(() => import("src/pages/purchase/pheebsTiger"))

const Index = lazy(() => import("src/pages/index"))
const Oauth2 = lazy(() => import("src/pages/oauth2"))
const lazyLoad = (component: ReactNode): JSX.Element => (
  <Suspense fallback={<Loading color="primary" />}>{component}</Suspense>
)

const router: RouteObject[] = [
  {
    path: "/act",
    children: [
      {
        path: "a20211224mysterybox",
        element: lazyLoad(<A20211224mysterybox />),
      },
      {
        path: "facialmask",
        element: lazyLoad(<FacialMask />),
      },
      {
        path: "facialmaskhome",
        element: lazyLoad(<FacialMaskHome />),
      },
      {
        path: "azzza",
        element: lazyLoad(<Azzza />),
      },
      {
        path: "pheebstiger",
        element: lazyLoad(<PheebsTiger />),
      },
    ],
  },
  {
    path: "/purchase",
    children: [
      {
        path: "pheebstiger",
        element: lazyLoad(<PheebsTigerPurchase />),
      },
      {
        path: "azzza",
        element: lazyLoad(<AzzzaPurchase />),
      },
      {
        path: "blindbox",
        element: lazyLoad(<BlindBox />),
      },
    ],
  },
  {
    path: "/act2/oauth2",
    element: lazyLoad(<Oauth2 />),
  },
  {
    path: "/*",
    element: lazyLoad(<Index />),
  },
]

export default router
